import bgTranslations from "@shared/i18n/locales/polaris_bg.json";
import enTranslations from "@medentic/polaris-react/locales/en.json";
import React, { ReactNode } from "react";
import { AppProvider } from "@medentic/polaris-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface PolarisProviderProps {
  children: ReactNode;
}

const PolarisProvider: React.FC<PolarisProviderProps> = ({ children }) => {
  const { i18n } = useTranslation();
  interface AdapterLinkProps {
    url: string;
    external?: boolean;
    children?: React.ReactNode;
    className?: string;
    onClick?: (event: React.MouseEvent) => void;
    onMouseEnter?: (event: React.MouseEvent) => void;
    onMouseLeave?: (event: React.MouseEvent) => void;
    [key: string]: unknown;
  }

  const AdapterLink = React.forwardRef<HTMLAnchorElement, AdapterLinkProps>(
    ({ url, external = false, children, ...rest }, ref) => {
      if (external) {
        return (
          <a href={url as string} {...rest} target="_blank" ref={ref}>
            {children as ReactNode}
          </a>
        );
      } else {
        return (
          <Link to={url as string} {...rest} ref={ref}>
            {children as ReactNode}
          </Link>
        );
      }
    }
  );

  return (
    <AppProvider
      i18n={i18n.language === "bg" ? bgTranslations : enTranslations}
      linkComponent={AdapterLink}
    >
      {children}
    </AppProvider>
  );
};

export default PolarisProvider;
